import styled from "styled-components";

export const CustomGrid = styled.div`
    display: flex;
    gap: 10px;
    justify-content: right;
    align-items: center;
    order: 1;
    flex: 0 1 auto;
    align-self: auto;
    margin-top: 0;
`;

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    padding-inline: 24px;
`;
